import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isMacOS } from '../../utils/isMacOS';
export class Dropdown extends Component {
  constructor(props) {
    super(props);
    const { title } = this.props;

    this.state = {
      isListOpen: false,
      title,
      selectedItem: null,
      keyword: '',
      // list,
    };

    this.searchField = React.createRef();
  }

  componentDidMount() {
    const { select, list } = this.props;

    if (select && list.length > 0) {
      this.selectSingleItem(select);
    }
  }

  componentDidUpdate() {
    const { isListOpen } = this.state;

    setTimeout(() => {
      if (isListOpen) {
        window.addEventListener('click', this.close);
      } else {
        window.removeEventListener('click', this.close);
      }
    }, 0);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.close);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { list } = nextProps;

    if (JSON.stringify(list) !== JSON.stringify(prevState.list)) {
      return { list };
    }

    return null;
  }

  close = () => {
    this.setState({
      isListOpen: false,
    });
  }

  clearSelection = () => {
    const { name, title, onChange } = this.props;

    this.setState({
      selectedItem: null,
      title,
    }, () => {
      onChange(null, name);
    });
  }

  selectSingleItem = (item) => {
    const { list } = this.props;

    const selectedItem = list.find((i) => i.value === item.value);
    if(!selectedItem)
      return;
    this.selectItem(selectedItem);
  }

  selectItem = (item) => {
    const { label, value } = item;
    const { selectedItem } = this.state;
    const { name, onChange, list } = this.props;

    let foundItem;

    if (!label) {
      foundItem = list.find((i) => i.value === item.value);
    }

    this.setState({
      title: label || foundItem.label,
      isListOpen: false,
      selectedItem: item,
    }, () => selectedItem?.value !== value && onChange(item, name));
  }

  toggleList = () => {
    this.setState((prevState) => ({
      isListOpen: !prevState.isListOpen,
      keyword: '',
    }), () => {
      if (this.state.isListOpen && this.searchField.current) {
        this.searchField.current.focus();
        this.setState({
          keyword: '',
        });
      }
      if(this.props.scrollTo && this.state.isListOpen) {
        var list = document.querySelector('.dd-scroll-list');
        let listScrollTop;
        if(this.state.selectedItem) {
          // If value is selected show it always on top
          var top = this.state.selectedItem.value;
          listScrollTop = document.getElementById(`${this.props.name}_${top}`).offsetTop;
        } else {
          // We substract two values so that the focus element is right in the middle
          if(this.props.name === "coverage" && this.props.scrollTo) {
            listScrollTop = document.getElementById(`${this.props.name}_${this.props.scrollTo}`).offsetTop;
          } else {
            var top = this.props.scrollTo - 2;
            listScrollTop = document.getElementById(`${this.props.name}_${top}`).offsetTop;
          }
        }
        list.scrollTop = listScrollTop;
      }
    });
  }

  filterList = (e) => {
    this.setState({
      keyword: e.target.value.toLowerCase(),
    });
  }

  listItems = () => {
    const {
      id,
      searchable,
      checkIcon,
      styles,
      name
    } = this.props;
    const { listItem, listItemNoResult } = styles;
    const { keyword } = this.state;
    const {list} = this.props;
    let tempList = [...list];
    const selectedItemValue = this.state.selectedItem?.value;

    if (keyword.length) {
      tempList = list.filter((item) => item.label.toLowerCase().includes(keyword.toLowerCase()));
    }

    if (tempList.length) {
      return (
        tempList.map((item) => (
          <button
            id={`${name}_${item.value}`}
            type="button"
            className={`dd-list-item ${id}`}
            style={listItem}
            key={item.value}
            onClick={() => this.selectItem(item)}
          >
            {item.label}
            {' '}
            {item.value === selectedItemValue && (
              <span style={styles.checkIcon}>
                {/* {checkIcon || <Check />} */}
              </span>
            )}
          </button>
        ))
      );
    }

    return (
      <div
        className={`dd-list-item no-result ${id}`}
        style={listItemNoResult}
      >
        {searchable[1]}
      </div>
    );
  }

  render() {
    const {
      id,
      searchable,
      styles,
      titleBold
    } = this.props;
    const { isListOpen, title, selectedItem } = this.state;

    const {
      wrapper,
      header,
      headerTitle,
      list,
      listSearchBar,
      scrollList,
    } = styles;

    return (
      <div
        className={`dd-wrapper ${id}`}
        style={wrapper}
      >
        <button
          type="button"
          className={`dd-header ${id} ${isListOpen ? "show" : ""} ${!isMacOS() && "not-mac-os"}`}
          style={header}
          onClick={this.toggleList}
        >
          <div
            className={`dd-header-title ${id} ${selectedItem && titleBold ? 'font-weight-bold':""} ${!isMacOS() && "not-mac-os"}`}
            style={headerTitle}
          >
            {title}
          </div>
        </button>
        {isListOpen && (
          <div
            className={`dd-list${searchable ? ' searchable' : ''} ${id}`}
            style={list}
          >
            {searchable
            && (
            <input
              ref={this.searchField}
              className={`dd-list-search-bar ${id}`}
              style={listSearchBar}
              placeholder={searchable[0]}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => this.filterList(e)}
            />
            )}
            <div
              className={`dd-scroll-list ${id}`}
              style={scrollList}
            >
              {this.listItems()}
            </div>
          </div>
        )}
      </div>
    );
  }
}

Dropdown.defaultProps = {
  id: '',
  select: undefined,
  searchable: undefined,
  styles: {},
  arrowUpIcon: null,
  arrowDownIcon: null,
  checkIcon: null,
};

Dropdown.propTypes = {
  id: PropTypes.string,
  styles: PropTypes.shape({
    wrapper: PropTypes.string,
    header: PropTypes.string,
    headerTitle: PropTypes.string,
    headerArrowUpIcon: PropTypes.string,
    headerArrowDownIcon: PropTypes.string,
    checkIcon: PropTypes.string,
    list: PropTypes.string,
    listSearchBar: PropTypes.string,
    scrollList: PropTypes.string,
    listItem: PropTypes.string,
    listItemNoResult: PropTypes.string,
  }),
  title: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  select: PropTypes.shape({ value: PropTypes.string }),
  searchable: PropTypes.shape([PropTypes.string, PropTypes.string]),
};